/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2024-10-29 10:28:11                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-01-21 12:38:42                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
*/

/* Imports */
import { Toaster } from "react-hot-toast";
import RealmLayout from "./components/realm/RealmLayout";
import DynamicTitle from "./components/dynamic-title/DynamicTitle";
/***/

function App() {
  return (
    <div className="App">
      <DynamicTitle />
      <RealmLayout />
      <Toaster
        toastOptions={{
          success: {
            style: {
              backgroundColor: "#ECFDF5",
              color: "#065F46",
            },
            iconTheme: {
              primary: "#065F46",
              secondary: "#ECFDF5",
            },
          },
          error: {
            style: {
              backgroundColor: "#FEF2F2",
              color: "#991B1B",
            },
            iconTheme: {
              primary: "#991B1B",
              secondary: "#FEF2F2",
            },
          },
        }}
      />
    </div>
  );
}

export default App;
